export const hasMissingConsents = (consents) =>
  !!consents.find(
    (consent) => !consent.optional && consent.currentConsent.toLowerCase() !== 'granted'
  );
